<template>
<div class="col-xl-4 col-lg-4 col-md-4 col-sm-8 col-xs-12">
      <!-- product grid item start -->
      <div class="product-item mb-10 ml-1 mr-1">
          <div class="product-thumb">
              <router-link :to="'/servicedetail/'+product.ArticleID" class="product-link">
                  <img :src="getPicture" alt="">
              </router-link>
              
              <div class="box-label">
                <template v-if="this.hasPackageData">
                <div class="product-label new"><span>PAKKET</span></div>
                </template>
              </div>
          </div>
          <router-link :to="'/servicedetail/'+product.ArticleID" class="product-link">
           <div class="text-center">
                  <div class="bottom-center-prod" style="word-wrap: break-word;">{{product.Title}}</div>
          </div>
          </router-link>
          <div>
            <div class="text-center">
              <router-link :to="'/servicedetail/'+product.ArticleID" class="product-link">
              <div class="price-box mt-10">
                  <div v-if="!isHideTime" >{{getDuration ()}}</div>
                  <div v-if="!isHidePrice">{{getProdPrice ()}}</div>
              </div>
              </router-link>
              <product-button :product="product" ></product-button>
          </div>
          </div>
      </div>
      <!-- product grid item end -->
  </div>

</template>

<script>
  import ProductButton from './ProductButton.vue'
  import Vue from 'vue';

  export default {
    name: 'product-item',
    props: ['product'],
    components: {
      'product-button': ProductButton
    },
     data () {
      return {
        urlPicCat : '',
        isHideTime : false,
        isHidePrice : false
      }
    },
    mounted () {
       this.urlPicCat = '';
       this.urlPicCat = Vue.$currCatPicUrl;

       if (Vue.$storeSettings != undefined)
       {
          this.isHideTime = Vue.$storeSettings.IsHideTime;
          this.isHidePrice =  Vue.$storeSettings.IsHidePrice;
       }
       
      // console.log ("loading pic 1:" + Vue.$currCatPicUrl)
    },
    activated () {
      //console.log ("loading pic :" + Vue.$currCatPicUrl)
      this.urlPicCat = Vue.$currCatPicUrl;
    },
    methods: {
       getDuration () {
          if (this.isHideTime) return " "
          if (this.product.IntDuration <= 0) return "  "
          return this.product.IntDuration + " min."
      },
      getProdPrice () {
          if (Vue.$storeSettings.IsHidePrices) return " "
          if ( parseFloat(this.product.Price) == 0) return " op aanvraag "
          var p = parseFloat(this.product.Price)
          return "€" + p.toFixed (2)
      }
    },
    computed: {
       hasPackageData () {
         this.urlPicCat = Vue.$currCatPicUrl;
         if (this.product.Childs == null) {return false;}
         if (this.product.Childs.length > 0) {return true;}
         return false;
       },
       getPicture () {
           this.urlPicCat = Vue.$currCatPicUrl;
           return this.urlPicCat; //Vue.$currCatPicUrl;
       }
     }
  }
</script>
<style>
  .product {
    background: #FFF;
    margin-bottom: 20px;
    position: relative;
    overflow: hidden;
  }

  .product-link {
    display: block;
    color: #3D3D3D;
  }
  
  .product .product__image {
    width: 100%;
    
  }
  .product__image img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: 225px;
  }
  .product__description {
    width: 100%;
    display: flex;
    padding: 20px 20px 15px;
    background: #FFF;
  }
  .product__info {
    flex: 2;
  }
  .product__description small {
    color: #808080;
  }
  .product__description h4 {
    margin: 3px 0 5px 0;
  }
  .product__price-cart {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 20px;
    font-weight: bold;
    color: #51D2B7;
  }
  .product__price-cart p {
    flex-grow: 2;
    font-size: 20px;
    font-weight: bold;
  }

  .product__action button {
    border-radius: 0;
    width: 100%;
    display: block;
  }
  .bottom-center-prod {
    color: #111111;
    border-radius: 10px;
    font-weight: 500;
    min-height: 40px;
    max-width: 95%;
    margin-left: 5px;
    background-color: rgba(238, 238, 238, 0.5);
  }
 
</style>



// WEBPACK FOOTER //
// src/components/products/ProductItem.vue